import styled from 'styled-components';

export const SecondSection = styled.div`
  margin: 24px 0 0 0;
`;
